import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import StandardMenu from '../StandardMenu/StandardMenu';
import s from './TextualMenu.scss';
// CR25B
// TODO: selected and header item styles
export var TextualMenu = function (_a) {
    var className = _a.className, itemClassName = _a.itemClassName, labelClassName = _a.labelClassName, props = tslib_1.__rest(_a, ["className", "itemClassName", "labelClassName"]);
    return (React.createElement(StandardMenu, tslib_1.__assign({ className: classnames(className, s['menu']) }, props)));
};
TextualMenu.displayName = 'TextualMenu';
export default TextualMenu;
//# sourceMappingURL=TextualMenu.js.map